import { Component } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-ask-navigation-modal',
  template: `
    <div class="title h5-normal shade-80">알고 계셨나요? ✨</div>
    <div class="description body2-alt1 shade-80">애스크는 메인 화면에서 언제나 확인할 수 있어요!</div>
    <img [src]="'assets/icons/ask-intro-modal-image.jpg' | imageUrl" />
    <div class="button-wrapper">
      <div class="button button1-normal white" (click)="onClickOK()">확인</div>
    </div>
  `,
  styles: [
    `
      .title {
        padding: 1.5rem 1rem 1.5rem 1.25rem;
      }
      .description {
        padding: 0 1.25rem;
      }
      img {
        margin-top: 1rem;
      }
      .button-wrapper {
        width: 100%;
        padding: 1rem 1.25rem 1.5rem;
      }
      .button {
        background-color: var(--blue-70);
        padding: 0.9375rem;
        text-align: center;
        border-radius: 6px;
      }
    `,
  ],
})
export class AskNavigationIntroModal {
  constructor(private modalService: ModalService) {}

  onClickOK(): void {
    this.modalService.dismiss()
  }
}
